module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "mt-5",
    class: _vm.calculatedClasses
  }, [_c('v-sheet', {
    staticClass: "v-sheet--offset mx-auto",
    attrs: {
      "color": "cyan",
      "elevation": "12",
      "max-width": "calc(100% - 32px)"
    }
  }, [_c('v-toolbar', {
    staticClass: "elevation-10",
    class: _vm.color,
    attrs: {
      "dense": "",
      "dark": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "loading": _vm.getRequest.loading || _vm.loading
    },
    on: {
      "click": _vm.get
    }
  }, [_c('v-icon', [_vm._v("person")])], 1), _vm._v(" "), (!_vm.isMobile) ? _c('v-tabs', {
    attrs: {
      "color": _vm.color
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_vm._l((_vm.pages), function(page) {
    return _c('v-tab', {
      key: page.title
    }, [_vm._v(_vm._s(page.title))])
  })], 2) : [_c('v-toolbar-title', [_vm._v("\n            " + _vm._s(_vm.activePage.title) + "\n          ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.isMobile) ? _c('v-menu', {
    staticClass: "v-tabs__div hidden-sm-and-up mr-0 pr-0",
    attrs: {
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('a', _vm._g({
          staticClass: "v-tabs__item",
          attrs: {
            "text": ""
          }
        }, on), [_vm._v("\n                MORE\n                "), _c('v-icon', [_vm._v("arrow_drop_down")])], 1)]
      }
    }], null, false, 664498919)
  }, [_vm._v(" "), _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.pages), function(page, index) {
    return _c('v-list-tile', {
      key: page.title,
      on: {
        "click": function($event) {
          return _vm.setTab(index)
        }
      }
    }, [_vm._v("\n                " + _vm._s(page.title) + "\n              ")])
  }), 1)], 1) : _vm._e()], _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.withDone) ? _c('v-btn', {
    staticClass: "hidden-xs-only",
    attrs: {
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("Done")]) : _vm._e()], 2)], 1), _vm._v(" "), (_vm.getRequest.loading) ? _c('tombstone') : _c('v-card-text', [_c('v-card-title', {
    staticClass: "title font-weight-light mb-2 hidden-xs-only",
    domProps: {
      "textContent": _vm._s(_vm.activePage.title)
    }
  }, [_c('v-spacer'), _vm._v(" "), (_vm.activePage.withSaveButton) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.saveRequest.loading,
      "small": ""
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n      ")]) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('request-status', {
    attrs: {
      "request": _vm.saveRequest
    }
  }), _vm._v(" "), (_vm.activePage.component) ? _c(_vm.activePage.component, _vm._b({
    tag: "component",
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "update:loading": function($event) {
        _vm.loading = $event
      },
      "reload": _vm.get
    }
  }, 'component', _vm.activePage.attrs, false)) : _vm._e()], 1), _vm._v(" "), (_vm.activePage.withSaveButton) ? _c('v-card-actions', [(_vm.withDone) ? _c('v-btn', {
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("\n      Cancel\n    ")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.withDone) ? _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "primary",
      "loading": _vm.saveRequest.loading,
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.closeOnSave = true;
        _vm.save()
      }
    }
  }, [_vm._v("\n      Save and close\n    ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.saveRequest.loading,
      "small": ""
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n      Save\n    ")])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d081ae0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/medicalaid/PatientInformationForm.vue
// module id = 1420
// module chunks = 9